import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';

// Utils
import { routes } from '@routes';

// UI
import { Link } from '@components/link';
import { TrustpilotMicroReviewWidget } from '@components/trustpilot-micro-review-widget';
type MainFooterNav = {
  [key: string]: Array<{
    name: string;
    href: string | (() => void);
    rel?: string;
    target?: string;
  }>;
};
const sections: MainFooterNav = {
  Company: [{
    name: 'About Us',
    href: routes.about
  }, {
    name: 'How It Works',
    href: routes.howItWorks
  }, {
    name: 'Journal',
    href: routes.blog
  }, {
    name: 'Press',
    href: routes.press
  }],
  Support: [{
    name: 'Help Center',
    href: routes.travlerHelp,
    target: '_blank',
    rel: 'nofollow'
  }, {
    name: 'Accessibility',
    href: routes.accessibility,
    rel: 'nofollow'
  }, {
    name: 'FAQs',
    href: routes.faq
  }],
  'For Hosts': [{
    name: 'List your Properties',
    href: routes.list
  }, {
    name: 'Pricing',
    href: routes.boost
  }, {
    name: 'Integrations',
    href: routes.integrations
  }, {
    name: 'Host support',
    href: routes.hostHelp
  }]
};
export const FooterSections: React.FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-white"><div className="flex space-x-4"><img src="/assets/svg/logos/savvy_wordmark_off_white.svg" className="block h-8 w-auto" alt="Savvy" /><p className="mt-1.5 text-lg">Stay smarter.</p></div><TrustpilotMicroReviewWidget className="mt-8 justify-start" styleWidth="267px" theme="dark" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid grid-cols-1 gap-y-12 lg:grid-cols-[450px_1fr]">{t0}<div className="grid grid-cols-1 gap-8 lg:gap-16 lg:grid-cols-3">{Object.keys(sections).map(_temp2)}</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(item) {
  return <li key={item.name}>{typeof item.href === "string" ? <Link className="font-normal text-white no-underline transition-colors hover:text-secondary-xlight hover:underline focus:text-secondary-xlight active:text-secondary-light" to={item.href} rel={item.rel} target={item.target}>{item.name}</Link> : <a className="cursor-pointer text-white no-underline transition-colors hover:text-secondary-xlight hover:underline focus:text-secondary-xlight active:text-secondary-light" onClick={item.href} rel={item.rel} target={item.target}>{item.name}</a>}</li>;
}
function _temp2(key) {
  return <div key={key}><h3 className="mb-4 text-lg font-medium">{key}</h3><ul className="space-y-2">{sections[key].map(_temp)}</ul></div>;
}